import React from 'react'

function BookComponent() {
    return (
        <div className='my-lg-5 my-2'>
            <div className='bookComponent mb-lg-5'>
                <div className='pt-lg-5 mainComponentCenter d-flex flex-column justify-content-center align-items-center'>
                    <h2 className='bookFont text-light mt-5 pt-lg-5 mt-lg-5 text-center'>
                        "CELEBRATE LIFE'S MOMENTS WITH HENNA."
                    </h2>
                    <p className='nav-item-main-subhead-extra text-light mt-lg-4'>
                        Connecting&nbsp; Hearts,&nbsp; Bridging&nbsp; Worlds:&nbsp; Together&nbsp; We&nbsp; Thrive!
                    </p>
                </div>
            </div>
        </div>
    )
}

export default BookComponent
